import { FC } from "react";
import { Tabs } from "@base-ui/react/tabs";
import { useSettings } from "./SettingsProvider";

interface Props {
    eventKey: string;
    children: React.ReactNode;
}

export const SettingsTabPane: FC<Props> = ({ eventKey, children }) => {
    const { validPaths } = useSettings();

    if (!validPaths.includes(eventKey)) {
        return null;
    }

    return <Tabs.Panel value={eventKey}>{children}</Tabs.Panel>;
};
